module.exports = __webpack_public_path__ + "img/warning-icon-error.f0a7fd85.svg";